import remoteConfirmationAPISlice from 'api/remoteConfirmation/remoteConfirmationAPISlice';

const useNumberOfPendingDonations = () => {
  const { data: pendingDonations, isLoading: isPendingDonationsLoading } =
    remoteConfirmationAPISlice.endpoints.getRemoteConfirmationPendingDonations.useQuery();

  if (isPendingDonationsLoading || !pendingDonations) {
    return 0;
  }

  return pendingDonations.donations.flatMap(({ donationItems }) => donationItems).length;
};

export default useNumberOfPendingDonations;
